import { Calendar, MapPin, ArrowRight } from "lucide-react";
import { events2026 } from "@/lib/data";

export const Agenda = () => (
  <section id="agenda" className="py-24 md:py-32 bg-[#FAFAFA]" data-testid="agenda-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <div>
          <span className="font-sans text-sm font-bold tracking-[0.25em] uppercase text-[#8B5CF6]">
            Dates fortes
          </span>
          <h2 className="mt-3 font-display text-5xl md:text-7xl leading-none uppercase">
            Agenda<span className="text-[#FF6B6B]">.</span>
          </h2>
        </div>
        <p className="md:max-w-md text-[#3a3a3a]">
          Les rendez-vous à venir — Early Bird des Stages CMI (jusqu'au 10 oct), Nébuleuse à Urrugne (21 nov) et la nouvelle masterclass Rôles féminins (12 déc). Pour le programme régulier, voir les activités.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {events2026.map((e, i) => (
          <article
            key={e.id}
            className={`relative border-2 border-black rounded-3xl p-7 shadow-brutal hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-brutal-sm transition-all flex flex-col`}
            style={{ backgroundColor: e.color }}
            data-testid={`event-card-${e.id}`}
          >
            {e.earlyBird && (
              <span className="mb-4 self-start bg-[#FF6B6B] text-white font-sans text-xs md:text-sm font-bold tracking-wider uppercase px-4 py-2 rounded-full border-2 border-black shadow-brutal-sm animate-pulse-slow">
                {e.earlyBird}
              </span>
            )}
            <div className="inline-flex items-center gap-2 bg-black text-white font-sans text-sm font-bold uppercase tracking-wider px-4 py-2 rounded-full self-start">
              <Calendar size={16} /> {e.dates}
            </div>
            <h3 className="mt-4 font-display text-3xl md:text-4xl uppercase leading-tight">{e.title}</h3>
            <div className="mt-3 flex items-center gap-2 text-sm font-medium">
              <MapPin size={14} /> {e.location}
            </div>
            <p className="mt-4 text-[#1a1a1a] leading-relaxed text-sm md:text-base">{e.description}</p>
            <a
              href={e.cta.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`event-cta-${e.id}`}
              className="mt-auto pt-6 inline-flex items-center gap-2 font-sans font-bold underline underline-offset-4 decoration-2 hover:gap-3 transition-all"
            >
              {e.cta.label}
              <ArrowRight size={16} />
            </a>
          </article>
        ))}
      </div>
    </div>
  </section>
);
